var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',{attrs:{"pills":"","small":""}},_vm._l((Object.keys(_vm.locales)),function(locale){return _c('b-nav-item',{key:locale,staticClass:"ml-1",attrs:{"active":_vm.currentLocale == locale,"link-classes":{
      'py-0 px-2 rounded': true,
      'text-danger': _vm.currentLocale !== locale && _vm.states[locale] == false,
      'bg-danger text-white': _vm.currentLocale == locale && _vm.states[locale] == false,
    }},on:{"click":function($event){$event.preventDefault();return _vm.change(locale)}}},[_vm._v("\n    "+_vm._s(locale)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }